<template>
  <div class="project-sales-report" v-if="project">
    <b-row v-if="showToGuest('salesReport', guestVisibleSections)">
      <b-col lg="8" md="8" sm="12">
        <legend>
          <strong>{{ $t('salesReport') }}: {{ $t('generate_report') }}</strong>
        </legend>
        <b-row>
          <b-col lg="4" md="7" sm="7">
            <AttachmentList
              :attachments="salesReportAttachments"
              :attachmentType="salesReportAttachmentType"
              v-on:attachment-list:delete="onDeleteAttachment"
            />
          </b-col>
          <b-col lg="8" md="5" sm="5">
            <router-link
              class="btn btn-success pull-right"
              :to="{
                name: 'SalesReportPrintPage',
                params: { projectNumber: project.number },
              }"
              target="_blank"
            >
              <i class="fa fa-file mr-2"></i>{{ $t('preview') }}
            </router-link>
            <ButtonWait
              v-if="!isGuest"
              :startCallback="startSalesReportBuild"
              :pollCallback="pollSalesReportBuildState"
              class="pull-right mr-2"
            >
              <template v-slot:buttonText>
                {{ $t('generate_report') }}
              </template>
            </ButtonWait>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-4" v-if="showToGuest('salesReport', guestVisibleSections)">
      <b-col lg="12" md="12" sm="12">
        <legend>
          <strong>{{ $t('salesReport') }}: {{ $t('collected_data') }}</strong>
        </legend>
        <MobileProjectsSalesReport :project="project" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MobileProjectsSalesReport from './MobileProjectsSalesReport.vue';
import ButtonWait from '@/components/ButtonWait.vue';
import AttachmentList from '@/components/AttachmentList';
import { canWriteField, showToGuest } from '@/helpers/userCapabilities';

/** Matches {@link PROJECT_ATTACHMENT_TYPES.SALES_REPORT} on the server */
const SALES_REPORT_ATTACHMENT_TYPE = 'SALES_REPORT';

export default {
  components: {
    MobileProjectsSalesReport,
    ButtonWait,
    AttachmentList,
  },
  props: {
    project: { type: Object },
  },
  data() {
    return {
      salesReportAttachmentType: SALES_REPORT_ATTACHMENT_TYPE,
      guestVisibleSections: {
        salesReport: true,
      },
    };
  },
  computed: {
    ...mapGetters('auth', ['isGuest']),
    salesReportAttachments() {
      if (!this.project || !this.project.attachments) {
        return [];
      }
      return this.project.attachments.filter(
        (attachment) => attachment.attachmentType === SALES_REPORT_ATTACHMENT_TYPE
      );
    },
  },
  methods: {
    ...mapActions(['buildSalesReport', 'fetchAttachmentBuildState']),
    async startSalesReportBuild() {
      if (this.project) {
        await this.buildSalesReport(this.project.id);
      }
    },
    async pollSalesReportBuildState() {
      return await this.fetchAttachmentBuildState({
        projectNumber: this.project.number,
        attachmentType: SALES_REPORT_ATTACHMENT_TYPE,
      });
    },
    onDeleteAttachment(event) {
      this.$emit('project-report-attachment-list:delete', {
        attachmentId: event.attachmentId,
        attachmentType: SALES_REPORT_ATTACHMENT_TYPE,
      });
    },
    canWriteField,
    showToGuest,
  },
};
</script>

<style lang="scss" scoped>
.verification-flex {
  display: flex;
  gap: 1em;
  flex-flow: row wrap;
  flex-basis: 100%;
  justify-content: flex-start;
}

.verification-flex > div {
  flex: 1;
  min-width: 300px;
}
</style>
